(function () {

  class CountDown extends HTMLElement {

    constructor() {

      super();


      this.startTime = this.dataset.startTime;
      this.endTime = this.dataset.endTime;


      this.startTimestamp = null;
      this.endTimestamp = null;


      this.daysEl = this.querySelector('.as-countdown-days');
      this.hoursEl = this.querySelector('.as-countdown-hours');
      this.minutesEl = this.querySelector('.as-countdown-minutes');
      this.secondsEl = this.querySelector('.as-countdown-seconds');


      this.timeWrap = this.querySelector('.as-countdown-time-wrap');

      this.textEl = this.querySelector('.as-countdown-text');


      this.timer = null;

    }



    connectedCallback() {


      if (!this.endTime) {

        console.error(
          'Countdown: Missing end time'
        );

        return;

      }



      /*
        Expected format:

        Start time:
        2026-08-01T08:00:00

        End time:
        2026-08-15T23:59:59

      */


      if (this.startTime) {

        this.startTimestamp =
          new Date(this.startTime).getTime();

      }



      this.endTimestamp =
        new Date(this.endTime).getTime();



      if (isNaN(this.endTimestamp)) {

        console.error(
          'Countdown: Invalid end time:',
          this.endTime
        );

        return;

      }



      console.log(
        'Countdown start:',
        this.startTime
      );


      console.log(
        'Countdown end:',
        this.endTime
      );



      // remove initial hidden state

      this.classList.remove('inactive');


      if (this.timeWrap) {

        this.timeWrap.classList.remove('inactive');

      }



      this.update();



      this.timer = setInterval(() => {

        this.update();

      }, 1000);


    }




    disconnectedCallback() {


      if (this.timer) {

        clearInterval(this.timer);

      }


    }





    update() {


      const now = Date.now();



      let targetTime;



      /*
        Before event starts

        Countdown to start time
      */

      if (

        this.startTimestamp &&
        now < this.startTimestamp

      ) {


        targetTime =
          this.startTimestamp;



        if (this.textEl) {

          this.textEl.textContent =
            this.textEl.dataset.start || '';

        }


      }



      /*
        Event running

        Countdown to end time
      */

      else {


        targetTime =
          this.endTimestamp;



        if (this.textEl) {

          this.textEl.textContent =
            this.textEl.dataset.end || '';

        }


      }





      const distance =
        targetTime - now;



      if (distance <= 0) {


        if (
          targetTime === this.endTimestamp
        ) {

          this.expired();

        }


        return;

      }





      const days =
        Math.floor(
          distance /
          (1000 * 60 * 60 * 24)
        );



      const hours =
        Math.floor(

          (distance %
            (1000 * 60 * 60 * 24))
          /
          (1000 * 60 * 60)

        );



      const minutes =
        Math.floor(

          (distance %
            (1000 * 60 * 60))
          /
          (1000 * 60)

        );



      const seconds =
        Math.floor(

          (distance %
            (1000 * 60))
          /
          1000

        );




      this.updateNumber(
        this.daysEl,
        days
      );


      this.updateNumber(
        this.hoursEl,
        hours
      );


      this.updateNumber(
        this.minutesEl,
        minutes
      );


      this.updateNumber(
        this.secondsEl,
        seconds
      );


    }





    updateNumber(element, value) {


      if (!element) return;


      element.textContent =
        String(value).padStart(2, '0');


    }





    expired() {


      if (this.timer) {

        clearInterval(this.timer);

      }



      if (this.timeWrap) {

        this.timeWrap.style.display =
          'none';

      }



      if (this.textEl) {

        this.textEl.textContent =
          this.textEl.dataset.end || '';

      }


    }


  }





  if (!customElements.get('count-down')) {


    customElements.define(
      'count-down',
      CountDown
    );


  }



})();